import { IIconProps } from "../types"

export default function IconUR6(props: IIconProps) {
  const width = props.size || props.width || 90
  const height = props.size || props.height || 78
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 90 78"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.3005 1.20275C38.4905 0.612745 47.6005 0.542745 54.6305 1.33275C61.6605 2.11275 66.6105 3.73274 69.9705 5.36274C73.3205 6.99274 75.0805 8.62275 77.1305 11.8727C79.1805 15.1327 81.5205 20.0127 83.5605 24.8627C85.6005 29.7127 87.3305 34.5327 88.1505 40.1627C88.9605 45.7927 88.8505 52.2427 88.1805 57.2827C87.5105 62.3327 86.2705 65.9727 84.4505 68.9027C82.6305 71.8327 80.2205 74.0527 77.7805 75.3227C75.3405 76.5927 72.8605 76.9127 69.3805 76.6227C65.9005 76.3327 61.4005 75.4127 57.5305 74.6327C53.6605 73.8527 50.4005 73.2027 47.6705 72.9127C44.9305 72.6127 42.7205 72.6827 40.5705 73.0427C38.4205 73.4027 36.3405 74.0527 34.0905 74.7627C31.8505 75.4827 29.4405 76.2627 27.2905 76.4627C25.1405 76.6527 23.2505 76.2627 20.6505 75.1927C18.0405 74.1127 14.7205 72.3527 12.1905 70.2127C9.65047 68.0627 7.89047 65.5227 6.29047 62.9127C4.70047 60.3127 3.27047 57.6427 2.32047 55.0427C1.38047 52.4327 0.920474 49.8927 0.790474 47.7127C0.660474 45.5327 0.860474 43.7127 1.15047 41.7927C1.44047 39.8727 1.83047 37.8527 4.02047 32.2227C6.20047 26.5927 10.1705 17.3427 13.0605 12.0327C15.9605 6.73275 17.7805 5.36274 20.3205 4.12275C22.8605 2.89275 26.1205 1.78275 32.3005 1.20275Z"
        fill="#E6E6E6"
        stroke="black"
        strokeWidth="1.5"
        strokeMiterlimit="2.61313"
      />
      <path
        d="M36.9922 30.1719C40.3822 33.2919 43.7622 36.4219 45.4222 38.5019C47.0822 40.5819 47.0222 41.6219 46.5122 47.1619C46.0022 52.6919 45.0622 62.7119 44.1122 72.7319"
        stroke="black"
        strokeWidth="1.5"
        strokeMiterlimit="2.61313"
      />
      <path
        d="M45.4219 38.5037C51.8619 36.1137 58.2919 33.7337 64.7319 31.3438"
        stroke="black"
        strokeWidth="1.5"
        strokeMiterlimit="2.61313"
      />
    </svg>
  )
}
